import Vue from 'vue/dist/vue.esm.js';
import Vuex from 'vuex';

Vue.use(Vuex)

export const store = new Vuex.Store({
	state: {
		songID: -1,
		pricingModalContent: '',
		searchQueryText: '',
		isPlaying: false,
		addToCartTrack: {}
	},
	getters: {
		getSongID: state => state.songID,
		getModalContent: state => state.pricingModalContent,
		getSearchQuery: state => state.searchQueryText,
		getPlayingStatus: state => state.isPlaying,
		getAddToCartTrack: state => state.addToCartTrack
	},
	mutations: {
		updatePlayingStatus( state, newStatus ) {
			state.isPlaying = newStatus;
		},
		updateSongID ( state, newID ) {
			state.songID = newID;
		},
		updatePricingModal ( state, newContent ) {
			state.pricingModalContent = newContent;
		},
		updateSearchQuery( state, newText ) {
			state.searchQueryText = newText;
		},
		updateAddToCartTrack( state, newTrack ) {
			state.addToCartTrack = newTrack;
		}
	},
})
